<div class="linkedin-preview">
  <div class="profile-header">
    <img
      class="profile-image"
      src="assets/img/basic_profil.svg"
      alt="Profile Picture"
    />
    <div class="profile-details">
      <ng-container *ngIf="user?.displayName">
        <div class="profile-name">{{ user?.displayName }}</div>
      </ng-container>
      <div class="post-date">{{ currentDate }}</div>
    </div>
  </div>
  <div id="post-content" class="post-content" [innerHTML]="linkedInPost"></div>
</div>
